
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'BoxComponent',
  data() {
    return {
      styles: {
        backgroundColor: '#faf0ca'
      }
    };
  }
});
